import { Frame } from '../Frame';

type EmbedProps = {
  attrs: {
    href: string;
  };
};

export const Loom = (props: EmbedProps): string => {
  const normalizedUrl = props.attrs.href.replace('share', 'embed'); // Normalize the Loom URL

  return Frame({
    src: normalizedUrl,
  });
};

// Add the isMatch function for Loom
Loom.isMatch = (href: string): boolean => {
  const loomRegex = /^https:\/\/(www\.)?(use)?loom\.com\/(embed|share)\/(.*)$/;

  return loomRegex.test(href);
};
